/**
 * Agrega situação de validade das licenças por empreendimento para o mapa.
 * Considera apenas licenças emitidas (status "3") para semáforo verde/amarelo/vermelho.
 */

export const EXPIRING_DAYS = 30;

/** Status de licença no órgão (ex.: frontend STATUS_LABELS). */
export const LICENCA_EMITIDA_STATUS = '3';

/**
 * @param {string|null|undefined} validadeStr data ISO YYYY-MM-DD
 * @returns {'expired'|'expiring'|'ok'}
 */
export function licencaHealth(validadeStr) {
  if (validadeStr == null || validadeStr === '') return 'ok';
  const raw = String(validadeStr).slice(0, 10);
  const parts = raw.split('-').map(Number);
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return 'ok';
  const d = new Date(parts[0], parts[1] - 1, parts[2]);
  if (Number.isNaN(d.getTime())) return 'ok';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (d < today) return 'expired';
  const diff = (d - today) / 86400000;
  if (diff <= EXPIRING_DAYS) return 'expiring';
  return 'ok';
}

/**
 * Por empreendimento, pior situação entre as licenças emitidas (vencida > a vencer > ok).
 * @param {Array<Record<string, unknown>>} licencas
 * @returns {Record<string, 'expired'|'expiring'|'ok'>}
 */
export function mergeLicenseStatusForEnterprises(licencas) {
  const byEmp = {};
  const rank = { expired: 3, expiring: 2, ok: 1 };
  for (const lic of licencas) {
    if (String(lic.status) !== LICENCA_EMITIDA_STATUS) continue;
    const eid = lic.empreendimento_id;
    if (!eid) continue;
    const h = licencaHealth(lic.validade);
    if (!byEmp[eid]) {
      byEmp[eid] = h;
    } else {
      const cur = byEmp[eid];
      byEmp[eid] = rank[h] > rank[cur] ? h : cur;
    }
  }
  return byEmp;
}

/**
 * Licenças emitidas com validade vencida (contagem global).
 */
export function countExpiredEmitidas(licencas) {
  return licencas.filter(
    (l) => String(l.status) === LICENCA_EMITIDA_STATUS && licencaHealth(l.validade) === 'expired'
  ).length;
}

/**
 * Licenças emitidas agrupadas por empreendimento, com semáforo de validade.
 * @param {Array<Record<string, unknown>>} licencas
 * @returns {Record<string, Array<{id: string, numero: string, validade: string, health: 'expired'|'expiring'|'ok'}>}
 */
export function summarizeIssuedLicensesByEnterprise(licencas) {
  const byEmp = {};
  for (const lic of licencas || []) {
    if (String(lic.status) !== LICENCA_EMITIDA_STATUS) continue;
    const eid = String(lic.empreendimento_id || '').trim();
    if (!eid) continue;
    const item = {
      id: String(lic.id || ''),
      numero: String(lic.numero || lic.codigo || lic.id || 'Licença'),
      validade: lic.validade ? String(lic.validade).slice(0, 10) : '',
      health: licencaHealth(lic.validade),
    };
    (byEmp[eid] ||= []).push(item);
  }
  return byEmp;
}
